export interface FundraisingDonationsPagination {
    total: number;
    sort?: string;
    page: number;
    pageSize: number;
}

export const initialValuesProjectDonationsPagination = {
    total: 0,
    sort: 'newest-first',
    page: 0,
    pageSize: 4,
} as FundraisingDonationsPagination;
